import React from 'react'
import { OverlayTrigger } from 'react-bootstrap';
import Tooltip from 'react-bootstrap/Tooltip';
import UseContact from '../hooks/useContact';
import Spinner from '../../../Components/spinner/spinner'

const Contact = () => {
  const {
    contactDelete,
    navigate,
    setPage,
    setDeleteShow,
    statusChange,
    contactsList,
    PER_PAGE,
    deleteShow,
    page,
    count,
    spinner,
  }=UseContact()
  return (
    <section className='position-relative'>
      <div className="" style={{height:'80vh'}}>
        {spinner && <Spinner />}

        <div className="row">
          {

            <div className="col-sm-12 listpadding">

              {
                // !listData.length ? <NoRecord />
                //   :
                <div className="table-responsive">
                  <table className="table cus-table">
                    <thead className="text-center tableheader">
                      <tr>
                        <th scope="col">Name</th>
                        <th scope="col">E-mail ID</th>
                        <th scope="col">Mobile Number</th>
                        <th scope="col"> Status</th>
                        <th scope="col">Action</th>
                        {/* {Action_Permission ? <th scope="col">Action</th> : null} */}
                      </tr>
                    </thead>
                    {/* {listData?.length === 0 ? <div className='position-absolute top-20 start-50 mt-5'><h3>No record found</h3></div> :
                        <tbody>
                          {listData?.map((item) => (<React.Fragment key={item._id}>
                            <tr className={Edit_Permission ? item?.isDeleted ? null : 'cursor' : null} style={{ background: item?.isDeleted ? "rgb(248 255 159 / 55%)" : "#fcf6f3" }}>
                              <td style={{ padding: '0.3rem .5rem' }} onClick={() => Edit_Permission ? item?.isDeleted ? null : navigate(`clientView/${item._id}`) : null}>
                                <span onClick={() => Edit_Permission ? item?.isDeleted ? null : navigate(`clientView/${item._id}`) : null}>
                                  <img alt="" src={(item.image === '' || item.image === null||item.image === 'null') ? DummyLogo : imgData + item.image} height={30} width={30} style={{ borderRadius: '50%' }} />
                                </span>
                              </td>
                              <td onClick={() => Edit_Permission ? item?.isDeleted ? null : navigate(`clientView/${item._id}`) : null}>{item.name}</td>
                              <td onClick={() => Edit_Permission ? item?.isDeleted ? null : navigate(`clientView/${item._id}`) : null}>{item.email}</td>
                              <td onClick={() => Edit_Permission ? item?.isDeleted ? null : navigate(`clientView/${item._id}`) : null}>{item.mobileNo}</td>
                              <td onClick={() => Edit_Permission ? item?.isDeleted ? null : navigate(`clientView/${item._id}`) : null}>{item.isAccepted?.charAt(0).toUpperCase() + item.isAccepted?.slice(1)}</td>
                              {
                                Action_Permission ?
                                  !item?.isDeleted ?
                                    <td>
                                      <Button variant="text" sx={{ color: 'black', fontSize: '12px' }} id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i className="fa-solid fa-ellipsis-vertical cursor"></i>
                                      </Button>
                                      <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                        {item.isActive ?
                                          <a className="dropdown-item cursor" onClick={() => { setClientDetail(item); setClientArchive(true) }}>Archived</a>
                                          :
                                          <a className="dropdown-item cursor" onClick={() => { setClientDetail(item); setClientArchive(true) }}>Un-Archived</a>
                                        }
                                        {item.isAccepted === 'Accepted' ? null : <a className="dropdown-item cursor" onClick={() => { setClientDetail(item); invitationReSend.setFieldValue('oldEmail', item.email); invitationReSend.setFieldValue('email', ''); setInvitationShow(true) }}>Resend Invitation</a>}
                                      </ul>
                                    </td>
                                    : <td>
                                      <i className="fa-solid fa-circle-exclamation cursor" onClick={() => { setDeletedAccountShow(true) }}></i>
                                    </td>
                                  : null
                              }

                            </tr>
                          </React.Fragment>))}
                        </tbody>
                      } */}
                  </table>
                  {/* <div className='w-100 d-flex justify-content-center'>
                      {listData.length === 0 ? null :
                        count > 10 &&
                        <Paginations setpage={setPage} count={Math.ceil(count / PER_PAGE)} page={page} />
                      }
                    </div> */}
                </div>
              }
            </div>
            // :
            // <div className='d-flex justify-content-center mt-5 me-5'><h3>You don't have permission to access</h3></div>
          }
        </div>
        <>
        <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Add Contact</Tooltip>}>
          <p className="btn addbtn2" onClick={() => { navigate('add-contact') }}>
            <i className="fa-solid fa-plus" ></i>
          </p>
        </OverlayTrigger>
      </>
      </div>

   

    </section>
  )
}

export default Contact